import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

class LabAsImInf2 extends React.Component {
  state={listRot: this.props.list, idListaP: [], verRotulo: false,
    procBtn: 0, permiteBtn1: true, confirmaAct: false, open: false
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
      // }
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {listRot, idListaP, verRotulo, permiteBtn1, confirmaAct, open} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let mensajeAsImLab = "Cargar imágenes de pruebas de laboratorio "
    let imgIcon1 = "images/archivo_32.png"

  let urlSlcm = 'https://montserratslcm.com/api/imglab/'
  return (
    <div>
      <List selection>
        <TitDer list={this.props.list} textBoton1="Imágenes de pruebas de laboratorio" btnNuevo={"NO"} styles={this.props.styles}/>

        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.props.handleUpdAsImLab(ev)
                :()=>{}
            :()=>{}}>         

            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '40%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      {mensajeAsImLab}
                    </label>
                    <input id="img" name="img" type="file" accept="image/*" multiple={true} style={estilos} onChange={(ev)=>this.props.handleUpdAsImLab(ev)}></input>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                  <EstaSeg7Btn imgIcon1={imgIcon1} 
                    open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                </div>
              </div>
            </div>
            
          </Form>
        </div>
      </List>
    </div>
  )
      }
};

export default compose( 
  graphql(queries.query.allPrueba, {name:'allPrueba', options: (props) => {return {variables: {}}}}),
)(LabAsImInf2)
